import { render, staticRenderFns } from "./TermsConditionsModal.vue?vue&type=template&id=6d05298d&scoped=true&"
import script from "./TermsConditionsModal.vue?vue&type=script&lang=js&"
export * from "./TermsConditionsModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsConditionsModal.vue?vue&type=style&index=0&id=6d05298d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d05298d",
  null
  
)

export default component.exports